import * as React from 'react';
import { Input, Col } from 'antd';

export default class InsertText extends React.Component<any> {

    state: any = {
        value: this.props.value
    };

    // 存储失去焦点前的合法值
    validateVal: any = this.props.value;

    // 返回合法值
    getValidateVal = (val: any): any => {
        const { max, min, getValidateVal } = this.props;
        let value: any = Number(val);
        if (typeof getValidateVal === 'function') {
            return getValidateVal(value);
        }
        if (isNaN(value) || !/(^[0-9]\d*$)/.test(value) || val.indexOf('.') > -1) {
            return this.validateVal;
        }
        if (value > max) {
            return String(max);
        }
        if (value < min) {
            return String(min);
        }
        return val;
    };

    // change 事件处理
    changeHandler = (e: any) => {
        const { onChange, value } = this.props;
        let currVal = e.target.value;
        this.validateVal = this.getValidateVal(value);
        // 记录当前值
        this.setState({ value: currVal });
        onChange && onChange(currVal);
    };

    // blur 事件处理
    blurHandler = () => {
        const { value, onBlur } = this.props;
        // 失焦时取得正确的值
        let newVal = this.getValidateVal(value);
        onBlur && onBlur(newVal);
    };

    render() {
        const { labelBefore, labelAfter, tips, disabled, initialValue, value } = this.props;
        return (
            <Input.Group>
                <Col span={6}><span>{labelBefore}</span></Col>
                <Col span={8}>
                    <Input style={{ margin: '0 10px', width: 80 }} disabled={disabled}
                           onChange={this.changeHandler} onBlur={this.blurHandler}
                           defaultValue={initialValue} value={value}/>
                    <span>{labelAfter}</span>
                </Col>
                <Col span={10}><span style={{ marginLeft: 24 }}>{tips}</span></Col>
            </Input.Group>
        );
    }
}
